import Vue from 'vue';
const EventBus = new Vue();

export default {
  install: function (Vue) {
    Vue.prototype.$eb = EventBus;
  }
}
